export const SUPPORT_EMAIL = 'help.sxm@salsify.com';
export const ONBOARDING_EMAIL = 'supplierxm-onboarding@salsify.com';
export const SALES_VIDEO_EMAIL = 'supplierxm-sales@salsify.com';
